module.exports = __webpack_public_path__ + "img/dh_goods.54317266.png";